module.exports = __webpack_public_path__ + "img/Cookie_1_resize_33.ddb55209.png";